module.exports = __webpack_public_path__ + "static/img/2.6eb682d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/3/eng/2.png
// module id = +JB3
// module chunks = 0